import { actions as resourcesActions } from "containers/Resources/Resources.reducer";
import { LIST_ACTION_CONCURRENCY } from "containers/Resources/listActionConcurrency";
import { Dispatch } from "redux";
import { runWithConcurrency } from "utils/runWithConcurrency";

export type ListActionProgressState = {
    current: number;
    total: number;
    label: string;
    // Acting table's scope (its tableSettingsKey). Omitted => global/unscoped,
    // shown in every toolbar (see listActionScope.ts).
    scopeId?: string;
};

export const updateListActionProgress = (
    dispatch: Dispatch,
    progress: ListActionProgressState
) => dispatch({ type: resourcesActions.LIST_ACTION_PROGRESS_UPDATE, progress });

export const clearListActionProgress = (dispatch: Dispatch, scopeId?: string) =>
    dispatch({ type: resourcesActions.LIST_ACTION_PROGRESS_CLEAR, scopeId });

export async function runListActionWithProgress<T, R>(
    dispatch: Dispatch,
    items: T[],
    label: string,
    worker: (item: T, index: number) => Promise<R>,
    scopeId?: string
): Promise<R[]> {
    if (items.length > 0) {
        updateListActionProgress(dispatch, { current: 0, total: items.length, label, scopeId });
    }

    try {
        return await runWithConcurrency(items, worker, {
            concurrency: LIST_ACTION_CONCURRENCY,
            onItemComplete: (completed, total) =>
                updateListActionProgress(dispatch, { current: completed, total, label, scopeId }),
        });
    } finally {
        clearListActionProgress(dispatch, scopeId);
    }
}
